// Reading.tsx

import React from 'react';
import './Photography.css';
import old from '../images/old.jpg';
import kid from '../images/kid.jpg';
import fire from '../images/fire.jpg';
import hyd from '../images/oldw.jpg';
import konarkSunTemple from '../images/konark.jpg';

const photos = [
  {
    title: "Waiting for death?",
    author: "Berhampur, Odisha",
    imgSrc: old,
    description: "As he waits, the ambient city sounds fade, and time seems suspended.",
  },
  {
    title: "Freedom is a state of mind!",
    author: "Gopalpur, Odisha",
    imgSrc: kid,
    description: "Pure joy — no rules, just the wind and the waves.",
  },
  {
    title: "A fire within",
    author: "Baxipalli, Gopalpur",
    imgSrc: fire,
    description: "When I'm behind the camera",
  },
  {
    title: "With you till the last day.!",
    author: "Hyderabad, Telangana.",
    imgSrc: hyd,
    description: "Loyalty etched in every heartbeat.",
  },
  {
    title: "The Sun Temple",
    author: "Konark, Odisha",
    imgSrc: konarkSunTemple,
    description: "Stone carvings basking in centuries of sunlight.",
  },
];

const Photography: React.FC = () => {
  return (
    <div className="reading-container">
      <h2 className="reading-title">📸 Capturing Moments, One Frame at a Time</h2>
      <p className="reading-intro">A glimpse into my lens — every photograph tells a story.</p>
      <div className="books-grid">
        {photos.map((book, index) => (
          <div key={index} className="book-card" style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}>
            <img src={book.imgSrc} alt={book.title} className="book-cover" />
            <div className="book-info">
              <h3 className="book-title">{book.title}</h3>
              <h4 className="book-author">{book.author}</h4>
              <p className="book-description">{book.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Photography;
